import * as React from "react";
import { SVGProps, memo } from "react";
const SvgNarrowSortArrowAscending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 19"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#333",
      }}
      d="m6.5 9-2-3.6-2 3.6H4v5h1V9z"
    />
  </svg>
);
const Memo = memo(SvgNarrowSortArrowAscending);
export default Memo;
